
export default function PartnerHero() {
  return (
    <div className="relative h-[45vh] sm:h-[60vh] flex items-center justify-center">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/bc389e986dfe60abc7a8d027d5cc97e5.jpg"
          alt="協力業者募集"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-blue-500/30 via-blue-400/20 to-blue-500/30"></div>
      </div>
      
      <div className="relative z-10 text-center text-white px-4 sm:px-6">
        <h1 className="text-3xl sm:text-5xl md:text-6xl font-bold drop-shadow-[0_4px_8px_rgba(0,0,0,0.5)]">
          協力業者募集
        </h1>
      </div>
    </div>
  );
}
